(() => {
  const withSmoocheButton = (Base) => class extends Base {
    toggleAddButton(disable = true, text) {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const button = form?.querySelector('[name="add"]');
      if (!button) return;

      button.toggleAttribute('disabled', disable);
      const label = button.querySelector('.atctxt');
      if (label && (!disable || text)) {
        label.textContent = disable ? text : window.variantStrings.addToCart;
      }
      const savings = button.querySelector('.atcSaving');
      if (savings) savings.style.display = disable ? 'none' : '';
    }

    setUnavailable() {
      this.toggleAddButton(true, window.variantStrings.unavailable);
      ['price', 'Inventory', 'Sku'].forEach((prefix) => {
        document.getElementById(`${prefix}-${this.dataset.section}`)?.classList.add('visibility-hidden');
      });
    }
  };

  ['variant-selects', 'variant-radios'].forEach((name) => {
    const target = `smooche-${name}`;
    const Base = customElements.get(name);
    if (Base && !customElements.get(target)) {
      customElements.define(target, withSmoocheButton(Base));
    }
  });

  if (!customElements.get('smooche-bundle-media')) {
    customElements.define('smooche-bundle-media', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('[id^="MainProduct-"]');
        const data = this.querySelector('[type="application/json"]');
        if (!this.section || !data) return;

        this.variantMedia = JSON.parse(data.textContent);
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.section.addEventListener('variant-selected', (event) => {
          if (!event.target.closest?.('kaching-bundles-block')) return;
          this.showVariant(event.detail?.variantId);
        }, options);

        this.section.addEventListener('variants-changed', (event) => {
          if (!event.target.closest?.('kaching-bundles-block')) return;
          const variants = event.detail?.variantIdQuantities;
          if (!Array.isArray(variants)) return;
          const selected = variants.filter((variant) => variant.quantity > 0);
          if (selected.some((variant) => String(variant.variantId) === this.selectedVariantId)) return;
          const variant = selected.find((item) => this.variantMedia[item.variantId]);
          if (variant) this.showVariant(variant.variantId);
        }, options);
      }

      showVariant(variantId) {
        const featuredMediaId = this.variantMedia[variantId];
        if (!featuredMediaId) return;
        this.selectedVariantId = String(variantId);
        const mediaId = `${this.section.dataset.section}-${featuredMediaId}`;

        this.section.querySelectorAll('media-gallery').forEach((gallery) => {
          const media = gallery.querySelector(`.product__media-item[data-media-id="${mediaId}"]`);
          if (!media || media.classList.contains('is-active')) return;
          if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(mediaId, false);
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
})();
